import { render, staticRenderFns } from "./SalesmanMaterial.vue?vue&type=template&id=4595e572&scoped=true&"
import script from "./SalesmanMaterial.vue?vue&type=script&lang=js&"
export * from "./SalesmanMaterial.vue?vue&type=script&lang=js&"
import style0 from "./SalesmanMaterial.vue?vue&type=style&index=0&id=4595e572&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4595e572",
  null
  
)

export default component.exports